export default __webpack_public_path__ + "static/media/chips.6386cddb.svg";